import { Switch, Route } from 'react-router-dom';
import ApplicationMaintenance from './ApplicationMaintenance';
import NewApplication from './NewApplication';
import { UserContext } from 'context/User/UserContext';
import { useContext } from 'react';

const AppMaintenanceRouter = () => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	return (
		<Switch>
			<Route
				path='/ApplicationMaintenance/NewApplication'
				render={() => <NewApplication currentUser={user} />}
			/>
			<Route
				path='/ApplicationMaintenance'
				render={() => <ApplicationMaintenance currentUser={user} />}
			/>
		</Switch>
	);
};

export default AppMaintenanceRouter;
